import PropTypes from "prop-types";

const Icon = ({ icon, className }) => {
  const {
    default: { viewBox, id }
  } = require(`../../../../styles/icons/${icon}.svg`);

  return (
    <svg viewBox={viewBox} className={className}>
      <use xlinkHref={`#${id}`} />
    </svg>
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default Icon;
